import { API } from 'api'
import { UserProfile, TUserAttribute } from 'shared'

export interface AUTH {
  email: string
  password: string
}

const ENDPOINT = '/user'

export const updateProfile = (profileData: Partial<UserProfile>) => {
  return API.patch(`${ENDPOINT}/profile`, profileData).then((res) => res.data)
}

export const getUserAttributes = (): Promise<TUserAttribute[]> => {
  return API.get(`${ENDPOINT}/user-attributes`).then((res) => {
    return res.data
  })
}
